import jsep from 'jsep';
import jsepObject from '@jsep-plugin/object';

jsep.plugins.register(jsepObject);
    
const opPrec = {"+":7,"-":7,"*":6,"**":4,"/":4,"//":4,">":12,"<":12,">=":12,"<=":12,
                "!=":12,"==":12,"&&":14,"||":15,"&":9,"|":11,"^":10 };
//"!":13
Object.keys(opPrec).forEach(op => { jsep.addBinaryOp(op, opPrec[op])});

//example of a predefined expr:
//   { name: "TEST", expr: 'CRON("*/30 * * * *", tav(TAG(P("source_tag", "_tagname", "tag"), 1000 * P("time", 1800, "int"), 0), 1800000, []))',
//   description: "There would be some help text here that could guide the user in how to set up the values for this custom choice."}

export function stringToExprWithCron(estr) {
    const ret = stringToExpr(estr);
    return (ret.n === 'CRON') ? {"cron": ret.a[0], ...ret.a[1] } : ret;
}

export function stringToExpr(estr) {
    let parse;
    parse = jsep(estr);
    //console.log("JSEP",estr, parse);
    function jnode(pnode, litmode) {
        function optarg(d) {
            if(d.a.length === 0) delete d.a;
            return d;
        }
        if(pnode.type === 'BinaryExpression') {
            return {
                'n':pnode.operator,
                'a':[jnode(pnode.left),jnode(pnode.right)]
            }
        } else if(pnode.type === 'CallExpression') {
            const nm = pnode.callee.name.split("$")
            const opts = (nm.length > 1) ? {'o': nm.slice(1)} : {}
            if(nm[0] === 'TAG') {
                const tag = jnode(pnode.arguments[0]);
                //todo: (maybe don't enforce this) check for string or param value (for legal tag)
                //if(typeof(tag) !== 'string' && tag?.n !== 'P' ) throw new Error("illegal tag id");
                return optarg({
                    ...opts,
                    'tag': tag,
                    'a': pnode.arguments.slice(1).map(jnode)
                })
            } else if(nm[0] === 'LITERAL') {
                return optarg({                        
                    'n':'lit',
                    'a': pnode.arguments
                })
            }
            return optarg({
                ...opts,                    
                'n':nm[0],
                'a':pnode.arguments.map(jnode)
            })
            //} else if(pnode.type === 'Identifier') {
            //   return { 'n':pnode.name }
        } else if(pnode.type === 'ObjectExpression') {
            function addprop(d, p) {
                //todo check key name and value to make sure literals or other acceptable non-compute type
                return d
            }
            const ret = pnode.properties.reduce(addprop, {})
            return litmode ? ret : { 'n':'lit', 'a': ret }
        } else if(pnode.type === 'ArrayExpression') {
            return pnode.elements.map(jnode)
        } else if(pnode.type === 'UnaryExpression' && pnode.operator === '-') {
            if(pnode.argument.type === 'Literal') {
                return -pnode.argument.value 
            } else {
                return {
                    'n': '-',
                    'a':[0, jnode(pnode.argument)]
                }
            }
        } else if(pnode.type === 'Literal') {
            if(typeof(pnode.value) !== "object") { //todo: was Object
                return pnode.value
            } else {
                return {
                    'n':'lit',
                    'a': pnode.value
                }
            }
        } else {
            throw new Error("unknown type:"+JSON.stringify(pnode))
        }
    }
    return jnode(parse);
}

export function exprToStringWithCron(jexpr, extractParams) {
    const ret = exprToString(jexpr, extractParams);
    return jexpr.cron ? 'CRON(' + exprToString(jexpr.cron, extractParams)
        + ', '+ret+')' : ret;
}

export function exprToString(jexpr, extractParams, pprec, prassoc) {
    function exprOptions(opts) {
        return (opts && opts.length) ? "$"+opts.join("$") : "";
    }
    if(typeof(jexpr) === 'object') {
      if(Array.isArray(jexpr)) {
          return "[" + jexpr.map((a) => exprToString(a, extractParams)).join(", ") + "]";
      } else {
        if(jexpr.n) {
            const prec = opPrec[jexpr.n]
            const rassoc = (jexpr.n === '**') ? 1 : 0 //only right assoc we have
            if(jexpr.n === 'lit') {
                return "LITERAL("+JSON.stringify(jexpr.a)+")";
            } else if(jexpr.a?.length === 2 && prec) { //operator
                const l = exprToString(jexpr.a[0], extractParams, prec, 0);
                const r = exprToString(jexpr.a[1], extractParams, prec, 1);
                if(pprec && !(prec > pprec) &&
                   (prec < pprec || rassoc !== prassoc))
                    return '(' + l + ' ' + jexpr.n + ' ' + r + ')';
                return l + ' ' + jexpr.n + ' ' + r;
            } else { //function
                if(extractParams != null && jexpr.n === 'P') {
                    const pkey = jexpr.a[0]; //error if not a simple string
                    extractParams[pkey] = [jexpr.a[1], jexpr.a[2]];
                }
                return jexpr.n+exprOptions(jexpr.o)+'('+jexpr.a.map(xx => exprToString(xx, extractParams)).join(", ") + ')';
            }
        } else if(jexpr.tag) {
            const a = (jexpr.a ? [jexpr.tag, ...jexpr.a] : [jexpr.tag])
                  .map(xx => exprToString(xx, extractParams)).join(", ")
            const tagexpr = "TAG"+exprOptions(jexpr.o)
            return tagexpr+'('+a+')'
        }
        // console.log("NODE", jexpr)
        throw new Error("bad node: "+JSON.stringify(jexpr))
      }
    }
    return JSON.stringify(jexpr);
}

const CVT = { opPrec, exprToString, exprToStringWithCron, stringToExprWithCron };

export default CVT;

